<template>
  <!-- Mobile Modal -->
  <TransitionRoot v-if="isMobile" :show="isOpen" as="template">
    <Dialog @close="$emit('close')" class="relative z-30">
      <!-- Backdrop -->
      <TransitionChild
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black/30" />
      </TransitionChild>

      <!-- Dialog -->
      <div class="fixed inset-0 flex items-center justify-center p-4">
        <TransitionChild
          enter="duration-300 ease-out"
          enter-from="opacity-0 scale-95"
          enter-to="opacity-100 scale-100"
          leave="duration-200 ease-in"
          leave-from="opacity-100 scale-100"
          leave-to="opacity-0 scale-95"
        >
          <DialogPanel class="rounded-lg bg-white p-6 h-svh sm:h-auto sm:max-h-[80vh] sm:w-[500px] w-screen flex flex-col">
            <SubscriptionsDialogContent 
              :is-open="isOpen"
              :scope="scope"
              :target-title="targetTitle"
              :current-watchlist="currentWatchlist"
              :events-to-create-alert-for="eventsToCreateAlertFor"
              :subscription-to-edit="subscriptionToEdit"
              :list-alerts-for-market-id="listAlertsForMarketId"
              :list-alerts-for-event-id="listAlertsForEventId"
              :list-alerts-for-watchlist-id="listAlertsForWatchlistId"
              :show-alert-list-tab-first="showAlertListTabFirst"
              @close="$emit('close')"
              @delete="$emit('delete', $event)"
              @edit="$emit('edit', $event)"
              @clear-filters="$emit('clear-filters')"
            />
          </DialogPanel>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>

  <!-- Desktop Div -->
  <SubscriptionsDialogContent 
    v-else
    :is-open="isOpen"
    :scope="scope"
    :target-title="targetTitle"
    :current-watchlist="currentWatchlist"
    :events-to-create-alert-for="eventsToCreateAlertFor"
    :list-alerts-for-market-id="listAlertsForMarketId"
    :list-alerts-for-event-id="listAlertsForEventId"
    :list-alerts-for-watchlist-id="listAlertsForWatchlistId"
    :subscription-to-edit="subscriptionToEdit"
    :show-alert-list-tab-first="showAlertListTabFirst"
    @close="$emit('close')"
    @delete="$emit('delete', $event)"
    @edit="$emit('edit', $event)"
    @clear-filters="$emit('clear-filters')"
  />
</template>

<script>
import { Dialog, DialogPanel, TransitionRoot, TransitionChild } from '@headlessui/vue'
import SubscriptionsDialogContent from './SubscriptionsDialogContent.vue'
import { SubscriptionScope } from '../types/Subscriptions'

export default {
  name: 'SubscriptionsDialogContainer',
  
  components: {
    Dialog,
    DialogPanel,
    TransitionRoot,
    TransitionChild,
    SubscriptionsDialogContent,
  },

  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    scope: {
      type: String,
      default: SubscriptionScope.WATCHLIST,
      required: false
    },
    targetTitle: {
      type: String,
      default: null,
      required: false
    },
    currentWatchlist: {
      type: Object,
      default: null,
      required: false
    },
    eventsToCreateAlertFor: {
      type: Object,
      default: null,
      required: false
    },
    subscriptionTypeConfig: {
      type: Object,
      default: {},
      required: false
    },
    subscriptionToEdit: {
      type: Object,
      default: null,
      required: false
    },
    listAlertsForMarketId: {
      type: String,
      default: null,
      required: false
    },
    listAlertsForEventId: {
      type: String,
      default: null,
      required: false
    },
    listAlertsForWatchlistId: {
      type: String,
      default: null,
      required: false
    },
    showAlertListTabFirst: {
      type: Boolean,
      default: false,
      required: false
    },
  },
  mounted() {
    // print all props
  },
  created() {
  }
}
</script> 